<div class="unauth-body">
  <h1>Linksuite</h1>
  <h2>You do not have sufficient permissions to access this resource</h2>
  <h4>Please contact an administrator for more details</h4>
  <a href="/" (click)="login()">Return to login screen</a>
</div>
